import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { Link } from "react-router-dom";

import CS from "../../commons/services/Common";
import { ROUTES } from "../../commons/constants/routes/routes";

class FirmwareMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      totalCount: 0,
    };
  }

  componentDidMount() {
    this.getItems();
  }

  async getItems() {
    try {
      const res = await axios.get("/api/v1/rtu/ota");
      this.setState({
        items: res.data.data || [],
        totalCount: res.data.recordsTotal || 0,
      });
    } catch (e) {
      console.log(e);
    }
  }

  handleDelete = async (id) => {
    const result = await CS.delete(`/api/v1/rtu/ota/${id}`);
    if (result.isSuccess) {
      this.getItems();
    }
  };

  // window.open은 axios 인터셉터(Authorization 헤더)를 타지 않아 인증이 필요한
  // 다운로드 API에는 쓸 수 없다. blob으로 받아 강제 다운로드한다.
  handleDownload = async (row) => {
    if (!row.version) return;
    try {
      const res = await axios.get(`/api/v1/rtu/ota/${row.version}/download`, {
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = row.filename || `${row.version}.bin`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { items, totalCount } = this.state;

    return (
      <Wrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">펌웨어 관리</h2>
            <Link to={ROUTES.FIRMWARE.CREATE} className="btn secondary">
              펌웨어 등록
            </Link>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <p className="all">
              펌웨어 목록<span> 총 {totalCount}건</span>
            </p>
          </div>
          <div className="table-wrapper">
            <table className="h-table">
              <colgroup>
                <col style={{ width: "7%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "24%" }} />
                <col style={{ width: "27%" }} />
                <col style={{ width: "13%" }} />
                <col style={{ width: "17%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>버전</th>
                  <th>파일명</th>
                  <th>비고</th>
                  <th>등록일</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((row, index) => (
                    <tr key={row.id}>
                      <td>{index + 1}</td>
                      <td>{row.version}</td>
                      <td className="ellipsis" title={row.filename}>
                        <button
                          type="button"
                          className="filename-link"
                          onClick={() => this.handleDownload(row)}
                        >
                          {row.filename}
                        </button>
                      </td>
                      <td className="left">{row.bigo}</td>
                      <td>
                        {row.regDate &&
                          new Date(row.regDate).toISOString().split("T")[0]}
                      </td>
                      <td>
                        <Link
                          className="edit-link link-btn"
                          to={{
                            pathname: ROUTES.FIRMWARE.EDIT(row.id),
                            state: { item: row },
                          }}
                        >
                          수정
                        </Link>
                        <button
                          type="button"
                          className="delete-link link-btn"
                          onClick={() => this.handleDelete(row.id)}
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">등록된 펌웨어가 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  .page-tit .btn {
    width: 168px;
    border-radius: 8px;
  }
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .ellipsis {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .filename-link {
    background: none;
    border: none;
    padding: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--secondary-500);
    text-decoration: underline;
    cursor: pointer;
    font-size: inherit;
    &:hover {
      color: var(--secondary-600);
    }
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    text-decoration: none;
    border: none;
    cursor: pointer;
  }
  .edit-link {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: #fff;
    margin-right: 5px;
    &:hover {
      background-color: var(--secondary-600);
    }
  }
  .delete-link {
    background-color: #ff5353;
    border: 1px solid #ff5353;
    color: #fff;
    &:hover {
      background-color: #e64545;
    }
  }
`;

export default FirmwareMain;
